
import { AuthCheck } from "@/components/auth/AuthCheck";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { SettingsContent } from "@/components/settings/SettingsContent";
import { useProfileData } from "@/hooks/useProfileData";

export default function Settings() {
  const { profile, setProfile, isLoading, setIsLoading } = useProfileData();

  const handleAvatarUpdate = (url: string) => {
    setProfile(prev => ({ ...prev, avatar_url: url }));
  };

  const handleProfileUpdate = (updatedProfile: typeof profile) => {
    setProfile(updatedProfile);
  };

  return (
    <AuthCheck>
      <DashboardLayout 
        avatar={profile.avatar_url !== "/placeholder.svg" ? profile.avatar_url : null} 
        name={profile.full_name}
      >
        <SettingsContent 
          profile={profile}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          onAvatarUpdate={handleAvatarUpdate}
          onProfileUpdate={handleProfileUpdate}
        />
      </DashboardLayout>
    </AuthCheck>
  );
}
